module.exports = __webpack_public_path__ + "static/media/arrow-right.2dc7b237.svg";